import {
  Checkbox,
  Chip,
  FormControl,
  Grid,
  Hidden,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  MenuProps,
  Select,
  Typography,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import TextFieldMultiOutlined from "../../../components/common/TextFieldMultiOutlined";
import UserContext from "../../../context/user-context";
import useInputUserChange from "../../../hooks/useInputUserChange";
import { useStore } from "../../../hooks/useStore";
import { useTranslation } from "../../../hooks/useTranslation";
import { GuestType } from "../../../store/types/userTypes";
import { CompanionTabIndex, EntrantTabIndex } from "../../../utils/tabIndex";
import { useStyles } from "./ProviderDetailsStyles";

const ConfigMenuProps: Partial<MenuProps> = {
  PaperProps: {
    style: {
      maxHeight: "70%",
      width: 250,
    },
  },
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    horizontal: "left",
    vertical: "top"
  },
  getContentAnchorEl: null
};

const ProviderDetails = () => {
  const classes = useStyles();
  const { state } = useContext(UserContext);
  const { authStore } = useStore();
  const { t, BundleKey } = useTranslation();
  const [typeOfProvider, setTypeOfProvider] = useState<string[]>(
    state.professionTypes || []
  );
  const { handleInputChange } = useInputUserChange();

  const handleChange = (event: any) => {
    setTypeOfProvider(event.target.value as string[]);
    handleInputChange("professionTypes", event.target.value);
  };

  const viewProfessions = (id: string) => {
    const data = authStore.professionTypes.find((item) => item.id === id);
    if (data) {
      return data.name;
    } else {
      return "-";
    }
  };

  useEffect(() => {
    state.authorizations.forEach((authorization) => {
      if (
        authorization.mark &&
        authorization.guestType === GuestType.provider
      ) {
        const professionType = authorization.authorization.providerType;
        if (professionType) {
          if (!typeOfProvider.some((id) => id === professionType.id))
            handleChange({
              target: { value: typeOfProvider.concat(professionType.id) },
            });
        }
      }
    });
  }, [JSON.stringify(state.authorizations)]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Hidden smDown>
          <Typography variant="h6" gutterBottom></Typography>
        </Hidden>
      </Grid>
      <Grid item xs={12}>
        <FormControl required className={classes.formControl}>
          <InputLabel id="typeOfProviderLbl">
            {t(BundleKey.DETAIL_PROVIDER_TYPE_PLACEHOLDER)}
          </InputLabel>
          <Select
            labelId="typeOfProviderLbl"
            id="typeOfProvider"
            autoFocus
            multiple
            value={typeOfProvider}
            onChange={handleChange}
            inputProps={{
              tabIndex: state.config?.companion
                ? CompanionTabIndex.selectProviders
                : EntrantTabIndex.selectProviders,
              type: "text",
            }}
            input={<Input id="select-multiple-chip" />}
            renderValue={(selected) => (
              <div className={classes.chips}>
                {(selected as string[]).map((value) => (
                  <Chip
                    key={value}
                    label={viewProfessions(value)}
                    className={classes.chip}
                  />
                ))}
              </div>
            )}
            MenuProps={ConfigMenuProps}
          >
            {authStore.professionTypes.map((profession) => (
              <MenuItem key={profession.id} value={profession.id}>
                <Checkbox checked={typeOfProvider.includes(profession.id)} />
                <ListItemText primary={profession.name} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <TextFieldMultiOutlined
          id="workMaterialsInput"
          name="workMaterials"
          label={t(BundleKey.DETAIL_PROVIDER_TOOLS_PLACEHOLDER)}
          inputProps={{ tabIndex: EntrantTabIndex.hidden }}
          rows={8}
          value={state.workMaterials}
          onChange={(value) => handleInputChange("workMaterials", value)}
        />
      </Grid>
    </Grid>
  );
};

export default ProviderDetails;
